export default __webpack_public_path__ + "7020ca9019c1a5fd2e79079329f2a999.png";